module.exports = __webpack_public_path__ + "img/2_002.ad5e87ea.webp";